import type { MarketingContentIndexEntry } from "./marketingContentLoader";

// The article's hero image is the largest thing on a blog post, and the imported Framer images are up
// to 1600px wide. Every image wider than this also has a copy resized to it (`<name>-w800.webp`, made
// once with `cwebp -resize 800 0`), which a phone gets instead: the article column is 720px at most, so
// 800px covers every phone at 2x and saves about two thirds of the bytes on the page's largest image.
export const HERO_IMAGE_SMALL_VARIANT_WIDTH = 800;

/** The `srcset` / `sizes` for an entry's hero image, or null when the image has no smaller copy. */
export function getHeroImageResponsiveAttributes(
  entry: Pick<MarketingContentIndexEntry, "heroImage" | "heroImageSize">
): {
  srcSet: string;
  sizes: string;
} | null {
  if (!entry.heroImage || !entry.heroImageSize || entry.heroImageSize.width <= HERO_IMAGE_SMALL_VARIANT_WIDTH)
    return null;
  const smallVariantUrl = entry.heroImage.replace(/\.webp$/, `-w${HERO_IMAGE_SMALL_VARIANT_WIDTH}.webp`);
  if (smallVariantUrl === entry.heroImage) return null;
  return {
    srcSet: `${smallVariantUrl} ${HERO_IMAGE_SMALL_VARIANT_WIDTH}w, ${entry.heroImage} ${entry.heroImageSize.width}w`,
    // The article column (marketingContent.css): full width on phones, 720px from there on.
    sizes: "(max-width: 767px) 100vw, 720px",
  };
}
